__turbopack_context__.v({
  "button-gap": "tab-bar-module-scss-module__qeEciW__button-gap",
  "buttons-container": "tab-bar-module-scss-module__qeEciW__buttons-container",
  "contained": "tab-bar-module-scss-module__qeEciW__contained",
  "horizontal": "tab-bar-module-scss-module__qeEciW__horizontal",
  "nav-button": "tab-bar-module-scss-module__qeEciW__nav-button",
  "nav-button-icon": "tab-bar-module-scss-module__qeEciW__nav-button-icon",
  "outline": "tab-bar-module-scss-module__qeEciW__outline",
  "primary": "tab-bar-module-scss-module__qeEciW__primary",
  "round": "tab-bar-module-scss-module__qeEciW__round",
  "secondary": "tab-bar-module-scss-module__qeEciW__secondary",
  "tab-bar": "tab-bar-module-scss-module__qeEciW__tab-bar",
  "transparent": "tab-bar-module-scss-module__qeEciW__transparent",
  "underline": "tab-bar-module-scss-module__qeEciW__underline",
  "vertical": "tab-bar-module-scss-module__qeEciW__vertical",
});
